(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  var MAX_BYTES = 20 * 1024 * 1024;
  var ALLOWED_EXT = ["pdf", "doc", "docx"];
  var ALLOWED_MIME = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ];

  DNB.CareerUpload = {
    init: function () {
      var blocks = document.querySelectorAll("[data-file-upload]");
      if (!blocks.length) return;

      Array.prototype.forEach.call(blocks, function (block) {
        DNB.CareerUpload._bind(block);
      });
    },

    _bind: function (block) {
      var input = block.querySelector(".file-upload__input");
      var dropzone = block.querySelector("[data-file-dropzone]");
      var trigger = block.querySelector("[data-file-trigger]");
      var hint = block.querySelector("[data-file-hint]");
      var errorEl = block.querySelector("[data-file-error]");
      var field = block.closest(".form-field");

      if (!input || !dropzone || !trigger) return;

      block._uploadState = "idle";
      block._uploadedFile = null;

      trigger.addEventListener("click", function () {
        if (block._uploadState === "complete") {
          DNB.CareerUpload._reset(block);
          if (field) field.classList.remove("is-error");
          return;
        }
        if (block._uploadState !== "uploading") input.click();
      });

      input.addEventListener("change", function () {
        if (input.files && input.files[0]) {
          DNB.CareerUpload._handleFile(block, input.files[0]);
        }
      });

      ["dragenter", "dragover"].forEach(function (evName) {
        dropzone.addEventListener(evName, function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (block._uploadState === "idle") dropzone.classList.add("is-dragover");
        });
      });

      ["dragleave", "drop"].forEach(function (evName) {
        dropzone.addEventListener(evName, function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropzone.classList.remove("is-dragover");
        });
      });

      dropzone.addEventListener("drop", function (e) {
        if (block._uploadState !== "idle") return;
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) DNB.CareerUpload._handleFile(block, file);
      });
    },

    _handleFile: function (block, file) {
      var input = block.querySelector(".file-upload__input");
      var dropzone = block.querySelector("[data-file-dropzone]");
      var trigger = block.querySelector("[data-file-trigger]");
      var hint = block.querySelector("[data-file-hint]");
      var errorEl = block.querySelector("[data-file-error]");
      var field = block.closest(".form-field");

      DNB.CareerUpload._hideError(block);

      if (!DNB.CareerUpload._isAllowedFile(file)) {
        DNB.CareerUpload._showError(block, block.getAttribute("data-msg-type") || "Yalnızca DOC veya PDF dosyası yükleyebilirsiniz.");
        if (field) field.classList.add("is-error");
        return;
      }

      if (file.size > MAX_BYTES) {
        DNB.CareerUpload._showError(block, block.getAttribute("data-msg-size") || "Dosya boyutu 20 MB sınırını aşıyor.");
        if (field) field.classList.add("is-error");
        return;
      }

      if (field) field.classList.remove("is-error");

      block._uploadState = "uploading";
      block._uploadedFile = file;
      dropzone.classList.add("is-uploading");

      var duration = Math.min(4000, Math.max(1200, file.size / 8000));
      var start = Date.now();

      function tick() {
        var elapsed = Date.now() - start;
        var progress = Math.min(100, Math.round((elapsed / duration) * 100));
        trigger.textContent = (block.getAttribute("data-msg-uploading") || "Yükleniyor %") + progress;

        if (progress < 100) {
          window.requestAnimationFrame(tick);
        } else {
          block._uploadState = "complete";
          dropzone.classList.remove("is-uploading");
          trigger.textContent = block.getAttribute("data-msg-remove") || "Dosya Sil";
          trigger.style.cursor = "pointer";
          hint.textContent = (block.getAttribute("data-msg-uploaded") || "Yüklenen dosya:") + " " + file.name + " (" + DNB.CareerUpload._formatSize(file.size) + ")";
        }
      }

      window.requestAnimationFrame(tick);

      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
      } catch (err) {}
    },

    _reset: function (block) {
      var input = block.querySelector(".file-upload__input");
      var dropzone = block.querySelector("[data-file-dropzone]");
      var trigger = block.querySelector("[data-file-trigger]");
      var hint = block.querySelector("[data-file-hint]");

      block._uploadState = "idle";
      block._uploadedFile = null;
      if (input) input.value = "";
      if (dropzone) dropzone.classList.remove("is-uploading", "is-dragover", "is-error");
      if (trigger) {
        trigger.textContent = block.getAttribute("data-label-choose") || "Dosya Seç";
        trigger.style.cursor = "";
      }
      if (hint) hint.textContent = block.getAttribute("data-label-hint") || "DOC yada PDF (max. 20 MB olmalı)";
      DNB.CareerUpload._hideError(block);
    },

    _isAllowedFile: function (file) {
      var ext = file.name.split(".").pop().toLowerCase();
      if (ALLOWED_EXT.indexOf(ext) !== -1) return true;
      if (file.type && ALLOWED_MIME.indexOf(file.type) !== -1) return true;
      return false;
    },

    _formatSize: function (bytes) {
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(1).replace(".", ",") + "mb";
      }
      return Math.max(1, Math.round(bytes / 1024)) + "kb";
    },

    _showError: function (block, message) {
      var errorEl = block.querySelector("[data-file-error]");
      var dropzone = block.querySelector("[data-file-dropzone]");
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      if (dropzone) dropzone.classList.add("is-error");
    },

    _hideError: function (block) {
      var errorEl = block.querySelector("[data-file-error]");
      var dropzone = block.querySelector("[data-file-dropzone]");
      if (errorEl) {
        errorEl.textContent = "";
        errorEl.hidden = true;
      }
      if (dropzone) dropzone.classList.remove("is-error");
    },

    isValid: function (block) {
      return block && block._uploadState === "complete" && block._uploadedFile;
    }
  };
})(window, document);
